import { getCurrentUser } from '@/utils/MemberInformation';
import { produce } from 'immer';
import { StateCreator } from 'zustand';

export interface UserSlice {
  user: {
    isLoggedIn: boolean;
    phoneNumber: string;
    lastName: string;
    firstName: string;
    email: string;
    gender: string;
    dob: string;
    preferredName: string;
    medicalReferral: string;
    clinicalConsent: boolean;
    termsConsent: boolean;
    cancellationPolicyConsent: boolean;
    referrerName: string | undefined;
    referrerPhoneNumber: string | undefined;
    [key: string]: any;
    errors: {
      [key: string]: string;
    };
    methods: {
      setCurrentUser: (newState: any) => void;
      remove: (field: string) => void;
      getErrors: () => { [key: string]: string };
      getMemberInfo: () => any;
      setError: (field: string, message: string) => void;
      clearErrors: () => void;
      removeError: (field: string) => void;
      setMemberInfo: (newState: any) => void;
    };
  };
}

const createUserSlice: StateCreator<UserSlice> = (set, get) => ({
  user: {
    isLoggedIn: false,
    phoneNumber: '',
    lastName: '',
    firstName: '',
    email: '',
    dob: '',
    gender: '',
    medicalReferral: 'false',
    referrerName: undefined,
    referrerPhoneNumber: undefined,
    preferredName: '',
    clinicalConsent: false,
    termsConsent: false,
    cancellationPolicyConsent: false,
    errors: {},
    methods: {
      setCurrentUser: (newState) => {
        set(
          produce((state) => {
            state.user = {
              ...state.user,
              ...getCurrentUser(newState),
              initialUserInfo: getCurrentUser(newState),
            };
          }),
        );
      },
      setMemberInfo: (newState) => {
        set(
          produce((state) => {
            state.user = {
              ...state.user,
              ...newState,
            };
          }),
        );
      },
      remove: (field) => {
        set(
          produce((state) => {
            delete state.user[field];
          }),
        );
      },
      getMemberInfo: () => {
        const { errors, methods, ...memberProperties } = get().user;
        return memberProperties;
      },
      getErrors: () => {
        return get().user.errors;
      },
      setError: (field, message) => {
        set(
          produce((state) => {
            state.user.errors[field] = message;
          }),
        );
      },
      clearErrors: () => {
        set(
          produce((state) => {
            state.user.errors = {};
          }),
        );
      },
      removeError: (field) => {
        set(
          produce((state) => {
            delete state.user.errors[field];
          }),
        );
      },
    },
  },
});

export default createUserSlice;
